import { render, staticRenderFns } from "./ApplicantOnboardingRegisterPage.vue?vue&type=template&id=d10702c4&"
import script from "./ApplicantOnboardingRegisterPage.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantOnboardingRegisterPage.vue?vue&type=style&index=0&id=d10702c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports